import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cart from "../components/Cart";
import "../styles/assets/colors.css";
import OrderDetailsForm from "../components/OrderDetailsForm";
import Swal from "sweetalert2";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { postData, getData } from "../services/api.service";
import instanceAPI from "../api/axios.service.js";
import { setUserData } from "../redux/userRedux/userActions";
import BackButton from "../components/common/BackButton";

const CartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { branch_id } = useParams();

  const cart = useSelector((state) => state.cart);
  const dataUser = useSelector((state) => state.user.dataUser);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState(null); // null, true (delivery), false (retiro)
  const [statusBranch, setStatusBranch] = useState(null);
  const [deliveryValue, setDeliveryValue] = useState(0);

  // Estado para datos de usuario (rellenados desde Redux)
  const [user, setUser] = useState({
    first_name: dataUser?.role_id === 3 ? "" : dataUser?.first_name || "",
    phone_number: dataUser?.role_id === 3 ? "" : dataUser?.phone_number || "",
  });
  const [orderDetails, setOrderDetails] = useState({});

  // Verificar si el usuario se logueó con Google y cargar datos si es necesario
  useEffect(() => {
    const checkSession = async () => {
      if (!dataUser) {
        setUserLoading(true);
        try {
          const response = await instanceAPI.get("/auth/me");
          if (response.data.success && response.data.user) {
            const userData = response.data.user;
            dispatch(
              setUserData({
                first_name: userData.first_name,
                last_name: userData.last_name,
                email: userData.email,
                role_id: userData.role_id,
                phone_number: userData.phone_number || "",
                provider: userData.provider || "LOCAL",
              })
            );
          }
        } catch (error) {
        } finally {
          setUserLoading(false);
        }
      }
    };

    checkSession();
  }, [dataUser, dispatch]);

  // Actualiza user si cambia dataUser en Redux
  useEffect(() => {
    if (dataUser) {
      if (dataUser.role_id !== 3) {
        setUser({
          first_name: dataUser.first_name || "",
          phone_number: dataUser.phone_number || "",
        });
      } else {
        // Si es cajero (role_id === 3), limpiar los datos
        setUser({
          first_name: "",
          phone_number: "",
        });
      }
    }
  }, [dataUser]);

  // Obtener estado de la sucursal
  useEffect(() => {
    const fetchBranchStatus = async () => {
      try {
        const resBranch = await getData(
          `/api/admin/get_status_branch/${branch_id}`
        );
        if (resBranch.status === 200) {
          setStatusBranch(resBranch.data.branch);
          setDeliveryValue(resBranch.data.branch[0]?.delivery_price || 0);
        } else {
          console.error("Error al obtener el estado de la sucursal");
        }
      } catch (error) {
        console.error("Error de red al obtener estado de sucursal:", error);
      }
    };

    fetchBranchStatus();
  }, []);

  useEffect(() => {
    const fetchTimes = async () => {
      // Solo consultar si hay método de entrega seleccionado
      if (deliveryMethod === null) {
        setAvailableTimes([]);
        return;
      }

      try {
        const deliveryParam = deliveryMethod ? 1 : 0;
        // TODO: Cuando el backend esté listo, usar: `/api/get_available_targets_time/${deliveryParam}/${branch_id}`
        const result = await getData(
          `/api/get_available_targets_time/${deliveryParam}/${branch_id}`
        );
        if (result && result.data) {
          setAvailableTimes(result.data.targets);
        } else {
          console.error(
            "Error al obtener los horarios: no se recibieron datos."
          );
          setAvailableTimes([]);
        }
      } catch (error) {
        console.error("Error de red al obtener horarios:", error);
        setAvailableTimes([]);
      }
    };

    fetchTimes();
  }, [deliveryMethod]); // Ejecutar cuando cambie el método de entrega

  // Función para manejar cambio en la forma de entrega
  const handleDeliveryMethodChange = (newDeliveryMethod) => {
    // Si cambia la forma de entrega, limpiar el horario seleccionado
    if (newDeliveryMethod !== deliveryMethod) {
      setDeliveryMethod(newDeliveryMethod);
      // Limpiar horario en orderDetails
      setOrderDetails((prev) => ({
        ...prev,
        end_time: "",
        delivery: newDeliveryMethod,
      }));
    }
  };

  if (userLoading) {
    return (
      <div className="bg-white min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="mt-3 text-dark">Cargando datos del usuario...</p>
        </div>
      </div>
    );
  }

  if (!cart.items || cart.items.length === 0) {
    return (
      <div className="container mt-5 text-center text-white">
        <div className="mb-3 d-flex justify-content-start">
          <div
            style={{
              backgroundColor: "#343a40",
              borderRadius: "8px",
              padding: "8px",
              display: "inline-block",
            }}
          >
            <BackButton />
          </div>
        </div>
        <h1>Carrito vacío</h1>
        <p>No hay productos en el carrito.</p>
        <Link to="/home/food_order">
          <button className="btn text-white bg-success">Hacer Pedido</button>
        </Link>
      </div>
    );
  }

  const handleDeleteItem = (index) => {
    dispatch({
      type: "REMOVE_CART_ITEM",
      payload: index,
    });
  };

  const handleEditItem = (index) => {
    const item = cart.items[index];
    if (item && item.burger) {
      // Navegar a la página de edición con los datos del burger
      navigate(
        `/home/food_order/${branch_id}/burguer_type/${item.burger.type_id}/size/${item.burger.size_id}`,
        {
          state: {
            size_short_desc: item.burger.sizeShortDesc,
            base_price: item.burger.base_price,
            extra_cheese_price: item.burger.extra_cheese_price,
            isEditing: true,
            editIndex: index,
            editData: {
              burger_id: item.burger.burger_id,
              selectedCheeses:
                item.burger.cheeses?.map((cheese) => cheese.id) || [],
              selectedToppings:
                item.burger.toppings?.map((topping) => topping.topping_id) ||
                [],
              selectedFriesAddons:
                item.burger.fries_addons?.map((addon) => addon.id) || [],
              extraCheese: item.burger.extraCheese,
              quantity: item.quantity,
              observation: item.burger.observation,
            },
          },
        }
      );
    }
  };

  const totalGeneral = cart.items.reduce((acc, item) => {
    // Validación defensiva: verificar que item.burger existe
    if (!item || !item.burger) {
      console.warn("Item sin datos de burger:", item);
      return acc;
    }

    let itemTotal =
      Number(item.burger.base_price || 0) +
      (item.burger.extraCheese
        ? Number(item.burger.extra_cheese_price || 0)
        : 0);
    if (item.burger.fries_addons && Array.isArray(item.burger.fries_addons)) {
      itemTotal += item.burger.fries_addons.reduce(
        (addonAcc, addon) => addonAcc + Number(addon.extra_price || 0),
        0
      );
    }
    return acc + itemTotal * Number(item.quantity || 1);
  }, 0);

  // Calcular el total incluyendo delivery si está seleccionado
  const totalWithDelivery =
    orderDetails.delivery === true
      ? totalGeneral + Number(deliveryValue)
      : totalGeneral;
  const validateOrderDetails = () => {
    if (orderDetails.delivery === null || orderDetails.delivery === undefined) {
      Swal.fire("Falta seleccionar forma de entrega", "", "warning");
      return false;
    }
    //Añadir name obligatorio 14/01/2026
    if (!orderDetails.name) {
      Swal.fire("Falta ingresar el nombre del cliente", "", "warning");
      return false;
    }
    //Añadir teléfono de contacto obligatorio 14/01/2026
    if (!orderDetails.contact_phone) {
      Swal.fire("Falta ingresar número de contacto", "", "warning");
      return false;
    }
    if (!orderDetails.end_time) {
      Swal.fire("Falta seleccionar horario de entrega/retiro", "", "warning");
      return false;
    }
    if (!orderDetails.pay_method) {
      Swal.fire("Falta seleccionar forma de pago", "", "warning");
      return false;
    }
    if (orderDetails.delivery === true && !orderDetails.order_address) {
      Swal.fire("Falta ingresar la dirección de entrega", "", "warning");
      return false;
    }
    return true;
  };
  const showModal = (action) => {
    Swal.fire({
      title: action === "buy" ? "¿Confirmar compra?" : "¿Seguir pidiendo?",
      text:
        action === "buy"
          ? "¿Deseas finalizar y enviar tu pedido?"
          : "¿Deseas agregar otra hamburguesa?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: action === "buy" ? "Comprar" : "Seguir pidiendo",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (action === "buy") {
          const cartWithIds = {
            ...cart,
            items: cart.items.map((item) => ({
              ...item,
              burger: item.burger
                ? {
                    ...item.burger,
                    size_id: Number(item.burger.size_id),
                    type_id: Number(item.burger.type_id),
                  }
                : undefined,
            })),
          };
          const data = JSON.stringify({
            ...orderDetails,
            cart: cartWithIds,
            branch_id: Number(branch_id), // ✅ Este branch_id viene de la URL
            status: 1,
            total_amount: totalWithDelivery,
          });

          console.log("Enviando pedido con branch_id:", branch_id); // Debug
          await postData("/api/cart/send_order", data)
            .then((response) => {
              if (response.status === 200) {
                Swal.fire({
                  title: "¡Orden creada exitosamente!",
                  text: "Tu pedido ha sido enviado correctamente",
                  icon: "success",
                  confirmButtonText: "Aceptar",
                }).then(() => {
                  // Borrar el carrito
                  dispatch({ type: "RESET_CART" });
                  // Redireccionar a la página de órdenes
                  const userRole = Number(dataUser?.role_id);

                  if (userRole === 3) {
                    // Si es cajero (rol 3), redirigir a pending orders
                    navigate("/cashier/pending_orders");
                  } else {
                    // Si es cliente normal, redirigir a sus pedidos
                    navigate("/orders");
                  }
                });
              } else if (response.status === 203) {
                Swal.fire({
                  title: "Error",
                  text: response.data.msg || "Hubo un problema con tu pedido.",
                  icon: "warning",
                  confirmButtonText: "Aceptar",
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "Error",
                text: "Hubo un problema al enviar tu pedido. Intenta nuevamente.",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
              console.error("Error al enviar la orden:", error);
            });
        } else {
          navigate(`/home/food_order/${branch_id}`);
        }
      }
    });
  };

  return (
    <div className="bg-white">
      <div className="container">
        <div className="pt-3">
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "8px",
              display: "inline-block",
              margin: "10px 0",
            }}
          >
            <BackButton />
          </div>
        </div>
        {cart.items.map((item, idx) => {
          // Validación: Solo renderizar items válidos con burger
          if (!item || !item.burger) {
            console.warn(
              `Item ${idx} sin datos de burger, omitiendo del render`
            );
            return null;
          }

          return (
            <div key={idx}>
              <Cart
                base_price={item.burger.base_price || 0}
                sizeShortDesc={item.burger.sizeShortDesc || ""}
                extraCheese={item.burger.extraCheese || false}
                extra_cheese_price={item.burger.extra_cheese_price || 0}
                selectedCheeses={item.burger.cheeses || []}
                selectedToppings={item.burger.toppings || []}
                selectedFries={item.burger.fries || []}
                selectedFriesAddons={item.burger.fries_addons || []}
                selectedDrinks={item.burger.drinks || []}
                quantity={item.quantity || 1}
                itemIndex={idx}
                onDelete={() => handleDeleteItem(idx)}
                onEdit={handleEditItem}
              />
              {item.burger.observation && (
                <div className="mb-5">
                  <strong>Observaciones:</strong> {item.burger.observation}
                </div>
              )}
            </div>
          );
        })}
        <h3 className="text-center">
          <strong>Finaliza tu pedido</strong>
        </h3>
        <OrderDetailsForm
          onChange={setOrderDetails}
          initialName={
            dataUser?.role_id === 3
              ? ""
              : `${user.first_name || ""} ${dataUser?.last_name || ""}`.trim()
          }
          initialPhone={dataUser?.role_id === 3 ? "" : user.phone_number || ""}
          availableTimes={availableTimes}
          onDeliveryMethodChange={handleDeliveryMethodChange}
        />
        <div className="text-center">
          {orderDetails.delivery === true && (
            <div className="mb-2">
              <h6 className="text-muted mb-1">
                Subtotal: <strong>${totalGeneral}</strong>
              </h6>
              <h6 className="text-muted mb-1">
                Delivery: <strong>${deliveryValue}</strong>
              </h6>
              <hr className="my-2" />
            </div>
          )}
          <h4 className="text-success mt-3">
            <strong>TOTAL FINAL: ${totalWithDelivery}</strong>
          </h4>
        </div>

        {statusBranch?.[0]?.closed === 1 && (
          <div className="alert alert-warning text-center my-3" role="alert">
            <strong>⚠️SUCURSAL CERRADA</strong>
            <br />
            <small>No se pueden procesar pedidos en este momento.</small>
          </div>
        )}

        <div className="d-flex justify-content-center gap-2 my-4 pb-4 col-12">
          <button
            className="btn bg-transparent border rounded-4 col-6"
            onClick={() => showModal("more")}
          >
            Seguir pidiendo
          </button>
          <button
            className={`btn border-0 rounded-4 col-6 ${
              statusBranch?.[0]?.closed === 1
                ? "bg-secondary text-muted"
                : "bg-red text-white"
            }`}
            disabled={statusBranch?.[0]?.closed === 1}
            onClick={() => {
              if (statusBranch?.[0]?.closed === 1) {
                Swal.fire({
                  title: "Sucursal cerrada",
                  text: "Lo sentimos, actualmente no estamos recibiendo pedidos.",
                  icon: "warning",
                  confirmButtonText: "Entendido",
                });
                return;
              }
              if (validateOrderDetails()) {
                showModal("buy");
              }
            }}
          >
            {statusBranch?.[0]?.closed === 1 ? "Sucursal cerrada" : "Comprar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
